exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-box[data-v-4570b43a]{width:240px}.slider-nav-more[data-v-4570b43a]{min-height:56px}", ""]);

// exports
